import { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { CiCircleRemove } from "react-icons/ci";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import {
  useAddNewSalesMutation,
  useGetInvoiceByInvQuery,
} from "../../features/api/orderinvoiceApi";
import {
  useGetMrTransactionQuery,
  useGetTransactionQuery,
} from "../../features/api/transactionApi";
import { toast } from "react-toastify";
import { useGetProductQuery } from "../../features/api/productApi";
import { useGetSubCategoryQuery } from "../../features/api/subcategoryApi.js";
import { useGetAllModelQuery } from "../../features/api/modelApi.js";
import { useGetSubjectsQuery } from "../../features/api/subjectApi.js";
import { getuser } from "../../components/CommonDateFormat.js";
import { FaPlus } from "react-icons/fa";
import SearchableSelect from "../../components/SearchableSelect.jsx";

const ProServiceBill = () => {
  const user = getuser();
  const { state } = useLocation();

  const [inv_date, setInvDate] = useState("");
  const [d_date, setDeliveryDate] = useState("");
  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setInvDate(currentDate);
    setDeliveryDate(currentDate);
  }, []);

  const [invcNo, setInvNo] = useState("");

  const { data } = useGetInvoiceByInvQuery(invcNo, {
    refetchOnMountOrArgChange: true,
  });
  const existInvoice = data?.data;

  const [subCatId, setSubCatId] = useState(14);
  const [proId, setProId] = useState(52);
  const [modelId, setModelId] = useState(119);
  const [dealer, setDealerName] = useState("");
  const [branch, setBranch] = useState("");
  const [jobId, setJobId] = useState("");
  useEffect(() => {
    if (state) {
      setDealerName(state?.clientId);
      setJobId(state?.jobId);
    }
  }, [state]);

  const [bill_sub, setSubject] = useState(11);
  const [bill_ref, setReference] = useState("");
  const [termCondition, setTermCondition] = useState("");
  const [modelAndSerial, setModelAndSerial] = useState("");
  const [vat, setVat] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [collect, setCollect] = useState(0);
  const [insertId, setInsertId] = useState("");

  const subCategory = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const productModels = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const findModel = productModels?.find((d) => d?.model_id == modelId);

  const dealers = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.dealer?.find((d) => d?.id == dealer);

  const subjects = useGetSubjectsQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.supplier;

  const allJv = useGetTransactionQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.transactions;

  let maxJv = 0;
  allJv?.forEach((jv) => {
    const jvNo = jv?.jv_no;
    const separateInv = jvNo?.split("-");
    const separateInvAgain = separateInv?.[2];
    if (!isNaN(separateInvAgain) && +separateInvAgain > +maxJv) {
      maxJv = +separateInvAgain;
    }
  });

  const currentYear = new Date(inv_date).getFullYear();
  const newJvNo = `JV-${currentYear}-${+maxJv + 1}`;

  const allMr = useGetMrTransactionQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data;

  let maxMr = 0;
  allMr?.map((data) => {
    const mrNo = data?.jv_no;
    const invSeperate = mrNo?.split("-");
    const generateAgain = invSeperate?.[2];
    if (!isNaN(generateAgain) && +generateAgain > +maxMr) {
      maxMr = generateAgain;
    }
  });
  const genMr = `MR-${currentYear}-${+maxMr + 1}`;

  const filterJv =
    allJv?.filter((d) => d?.ledger_id == 1 && d?.tag_ac_id == dealer) || [];
  let balance = 0;
  filterJv?.map((data) => {
    const { dabit_amount, credit_amount } = data;
    balance += dabit_amount - credit_amount;
    return balance;
  });

  // for save multiple purchase data
  const [newArray, setNewArray] = useState([]);
  const handleAddItem = () => {
    if (dealer === "") {
      toast.error("Client must required");
    } else {
      setNewArray([
        ...newArray,
        {
          inv_date: inv_date,
          d_date: d_date,
          dealer: dealer,
          sub_cat: Number(subCatId),
          pro_name: Number(proId),
          model_id: modelId,
          product:
            findModel?.subCategory +
            ": " +
            findModel?.product +
            ":" +
            findModel?.model_name,
          rmks: "",
          serial_no: "",
          qty: 1,
          sales_rate: 0,
          total: 0,
          type: 2,
          stock_type: 1,
        },
      ]);
    }
  };

  // handle quantity for individual product
  const handleQuantityChange = (index, qty) => {
    const updatedData = [...newArray];
    updatedData[index].qty = qty;
    updatedData[index].total = qty * updatedData[index].sales_rate;
    setNewArray(updatedData);
  };

  const handleStockChange = (index, qty) => {
    const updatedData = [...newArray];
    updatedData[index].stock_type = qty;
    setNewArray(updatedData);
  };

  const handleSerialChange = (index, serial) => {
    const updatedData = [...newArray];
    updatedData[index].serial_no = serial;
    setNewArray(updatedData);
  };

  // handle description for individual product
  const handleDescChange = (index, desc) => {
    const updatedData = [...newArray];
    updatedData[index].rmks = desc;
    setNewArray(updatedData);
  };

  // handle quantity for individual product
  const handleRateChange = (index, rate) => {
    const updatedData = [...newArray];
    updatedData[index].sales_rate = rate;
    updatedData[index].total = rate * updatedData[index].qty;
    setNewArray(updatedData);
  };

  const subTotal = newArray?.reduce((sum, item) => sum + item.total, 0);
  const vatAmount = subTotal * (vat / 100);
  const totalWithVat = subTotal + vatAmount;
  const totalWithDisc = totalWithVat - discount;
  const dues = totalWithDisc - collect;
  const grandTotal = totalWithDisc + balance;
  const duesForSee = grandTotal - collect;

  // remove from product list before purchase
  const handleRemove = (index) => {
    const restProduct = [...newArray];
    restProduct.splice(index, 1);
    setNewArray(restProduct);
  };

  const navigate = useNavigate();
  const [addNewSales] = useAddNewSalesMutation();
  // handle function for purchase product
  const [loading, setLoading] = useState(false);
  const handleOrder = async () => {
    setLoading(true);

    try {
      const response = await addNewSales({
        jv_no: newJvNo,
        genMr: genMr,
        jv_type: 5,
        mrType: 3,
        inv_no: invcNo,
        inv_date: inv_date,
        d_date: d_date,
        dealer: dealer,
        bill_sub: bill_sub,
        bill_ref: bill_ref,
        model_srl: modelAndSerial,
        term_cond: termCondition,
        branch: branch,
        sub_total: subTotal,
        discount: discount || 0,
        t_w_d: totalWithDisc,
        inv_pevdue: balance,
        paid: collect,
        inv_due: dues || 0,
        grand_total: grandTotal || 0,
        job_id: jobId,
        type: 2,
        created_by: user?.id,
        items: newArray,
      });
      if (response?.data) {
        setInsertId(response?.data?.ordersId);

        setLoading(false);
        // navigate("/dashboard/orders");
      } else if (response?.error) {
        setLoading(false);
        toast.error("Error occurred while creating");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error updating data:", error?.response);
    }
  };

  useEffect(() => {
    if (insertId) {
      navigate(`/dashboard/order/invoice/${insertId}`);
    }
  }, [insertId]);

  return (
    <div className="p-2 md:p-4 ">
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-bold">Create Service Bill</h1>
        <div className="flex items-center gap-x-2">
          <Link
            to="/dashboard/product-services"
            className="bg-blue-500 px-2 py-1 rounded text-white flex items-center gap-x-1"
          >
            <AiFillBackward /> Back{" "}
          </Link>
        </div>
      </div>
      <div className="">
        <div className="p-4 mt-2 border">
          <form className=" ">
            <div className="grid grid-cols-1 md:grid-cols-[0.7fr_0.5fr_0.5fr_2fr_1fr] md:gap-4">
              <div className="flex flex-col gap-1">
                <label className="font-bold">Bill No.</label>
                <input
                  type="text"
                  value={invcNo}
                  onChange={(e) => {
                    setInvNo(e.target.value);
                  }}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                />
                {existInvoice?.length > 0 && (
                  <p className="text-sm font-medium text-red-500">
                    Bill No. already exist
                  </p>
                )}
              </div>
              <div className="flex flex-col gap-1">
                <label className="font-bold">Bill Date</label>
                <input
                  type="date"
                  value={inv_date}
                  onChange={(e) => setInvDate(e.target.value)}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="font-bold">Delivery Date</label>
                <input
                  type="date"
                  value={d_date}
                  onChange={(e) => setDeliveryDate(e.target.value)}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="font-bold">Hospital Name</label>
                <input
                  type="text"
                  value={dealers?.d_name + "-" + dealers?.d_address}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                  // placeholder={dealer?.d_name + "-" + dealer?.d_address}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="font-bold">Branch</label>
                <input
                  type="text"
                  value={branch}
                  onChange={(e) => setBranch(e.target.value)}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                />
              </div>
            </div>

            <div className="flex flex-col gap-1 my-2">
              <label className="font-bold">Model & Serial No.</label>
              <textarea
                value={modelAndSerial}
                onChange={(e) => setModelAndSerial(e.target.value)}
                rows={2}
                className="border border-slate-300 rounded-sm pl-1"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr_2fr] md:gap-4 my-3">
              <div className="flex flex-col gap-1">
                <label className="font-medium">Brand</label>
                <select
                  value={subCatId}
                  onChange={(e) => setSubCatId(Number(e.target.value))}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                >
                  <option>--select--</option>
                  {subCategory?.map((sCat) => (
                    <option key={sCat?.id} value={sCat?.id}>
                      {sCat?.sub_catName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col gap-1">
                <label className="font-medium">Product</label>

                <SearchableSelect
                  options={[
                    { value: "", label: "--select--" },
                    ...(products?.map((i) => ({
                      value: i?.id,
                      label: i?.product_name,
                    })) || []),
                  ]}
                  value={proId}
                  onChange={(e) => setProId(Number(e.target.value))}
                />

                {/* <select
                  value={proId}
                  onChange={(e) => setProId(Number(e.target.value))}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                >
                  <option>--select--</option>
                  {products?.map((product) => (
                    <option key={product?.id} value={product?.id}>
                      {product?.product_name}
                    </option>
                  ))}
                </select> */}
              </div>
              <div className="flex flex-col gap-1">
                <label className="font-medium">Product Models</label>

                <SearchableSelect
                  options={[
                    { value: "", label: "--select--" },
                    ...(productModels
                      ?.filter((model) => model.product_id === +proId)
                      .map((i) => ({
                        value: i?.model_id,
                        label: i?.model_name,
                      })) || []),
                  ]}
                  value={modelId}
                  onChange={(e) => setModelId(Number(e.target.value))}
                />
                {/* <select
                  value={modelId}
                  onChange={(e) => {
                    setModelId(Number(e.target.value));
                  }}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                >
                  <option>--select--</option>
                  {productModels
                    ?.filter((model) => model.product_id === +proId)
                    .map((model) => (
                      <option key={model?.model_id} value={model?.model_id}>
                        {model?.model_name}
                      </option>
                    ))}
                </select> */}
              </div>

              <div className="flex flex-col gap-1">
                <label className="font-bold">Subject</label>
                <select
                  value={bill_sub}
                  onChange={(e) => setSubject(Number(e.target.value))}
                  className="border border-slate-300 rounded-sm h-8 pl-1"
                >
                  <option value={""}>--select--</option>
                  {subjects?.map((subject) => (
                    <option key={subject?.id} value={subject?.id} className="">
                      {subject?.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </form>
          <div className="mt-2 flex flex-col gap-y-2">
            <div className="flex flex-col gap-1">
              <label className="font-bold">Reference</label>
              <textarea
                onChange={(e) => setReference(e.target.value)}
                rows={2}
                className="border border-slate-300 rounded-sm pl-1"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="font-bold">Terms & Conditions</label>
              <textarea
                value={termCondition}
                onChange={(e) => setTermCondition(e.target.value)}
                rows={2}
                className="border border-slate-300 rounded-sm pl-1"
              />
            </div>
          </div>
          <button
            onClick={() => handleAddItem()}
            className="bg-white border border-black px-4 py-1   font-bold flex items-center gap-1 mx-auto mt-4"
          >
            <FaPlus size={14} /> <span>Add</span>
          </button>
        </div>
        <div className="p-2 m-2 border w-full mx-auto overflow-auto bg-white">
          <table className=" bg-white shadow-lg w-full">
            <thead>
              <tr>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Product Name
                </th>
                {modelId == 133 ? (
                  ""
                ) : (
                  <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                    Serial
                  </th>
                )}
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Description
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Sales Rate
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Quantity
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Stock
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Total Amount
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {newArray?.map((data, index) => {
                return (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {data?.product}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        type="text"
                        onChange={(e) =>
                          handleSerialChange(index, e.target.value)
                        }
                        className="border pl-1 w-24 focus:outline-none"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <textarea
                        onChange={(e) =>
                          handleDescChange(index, e.target.value)
                        }
                        className="border focus:outline-none text-sm h-12 "
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        type="number"
                        defaultValue={data?.sales_rate}
                        onChange={(e) =>
                          handleRateChange(index, Number(e.target.value))
                        }
                        className="w-20 border focus:outline-none"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        onChange={(e) =>
                          handleQuantityChange(index, Number(e.target.value))
                        }
                        type="number"
                        defaultValue={data?.qty}
                        className="border pl-1 w-16 focus:outline-none"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        onChange={(e) =>
                          handleStockChange(index, e.target.checked ? 1 : 0)
                        }
                        type="checkbox"
                        checked={data.stock_type === 1}
                        className="border pl-1 w-16 focus:outline-none cursor-pointer"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {data?.total}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <button
                        onClick={() => handleRemove(index)}
                        className="text-xl text-white bg-red-500 rounded-full"
                      >
                        <CiCircleRemove />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <thead className="text-sm">
              <tr className="">
                <th
                  colSpan={6}
                  className="px-6 py-3 border-b-2 font-bold text-xs border-gray-300 text-right uppercase tracking-wider"
                >
                  Sub-Total:
                </th>
                <th
                  // colSpan={}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left font-bold text-xs uppercase tracking-wider"
                >
                  <p className="border p-1 text-xs"> {subTotal}</p>
                </th>
              </tr>
              <tr className="">
                <th
                  colSpan={6}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right font-bold text-xs uppercase tracking-wider"
                >
                  Discount:
                </th>
                <th
                  // colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left  font-bold text-xs uppercase tracking-wider"
                >
                  <input
                    onChange={(e) => setDiscount(Number(e.target.value))}
                    type="text"
                    defaultValue={discount}
                    className="border p-1  focus:outline-none text-xs"
                  />
                </th>
              </tr>
              <tr className="">
                <th
                  colSpan={6}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right font-bold text-xs uppercase tracking-wider"
                >
                  Total:
                </th>
                <th
                  // colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left font-bold text-xs uppercase tracking-wider"
                >
                  <p className="border p-1 text-xs"> {totalWithDisc}</p>
                </th>
              </tr>
              <tr className="">
                <th
                  colSpan={6}
                  className="px-6 py-3 border-b-2 font-bold text-xs border-gray-300 text-right uppercase tracking-wider"
                >
                  previous due:
                </th>
                <th
                  // colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left font-bold text-xs uppercase tracking-wider"
                >
                  <p className="border p-1 text-xs"> {balance}</p>
                </th>
              </tr>
              <tr className="hidden">
                <th
                  colSpan={6}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right font-bold uppercase tracking-wider"
                >
                  VAT(%):{" "}
                  <input
                    onChange={(e) => setVat(e.target.value)}
                    type="number"
                    defaultValue={vat}
                    className="border p-1"
                  />
                </th>
                <th
                  // colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider"
                >
                  {vatAmount}
                </th>
              </tr>

              <tr>
                <th
                  colSpan={6}
                  className="px-6 py-3 border-b-2 font-bold text-xs border-gray-300 text-right uppercase tracking-wider"
                >
                  Grand-Total:
                </th>
                <th
                  // colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left font-bold text-xs uppercase tracking-wider"
                >
                  <p className="border p-1 text-xs"> {grandTotal}</p>
                </th>
              </tr>
              <tr>
                <th
                  colSpan={6}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right font-bold text-xs uppercase tracking-wider"
                >
                  Paid Amount:
                </th>
                <th
                  // colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left font-bold text-xs uppercase tracking-wider"
                >
                  <input
                    onChange={(e) => setCollect(Number(e.target.value))}
                    type="text"
                    value={collect}
                    className="border p-1 focus:outline-none text-xs"
                  />
                </th>
              </tr>
              <tr>
                <th
                  colSpan={6}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right font-bold text-xs uppercase tracking-wider"
                >
                  Due Amount:
                </th>
                <th
                  // colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left font-bold text-xs uppercase tracking-wider"
                >
                  <p className="border p-1"> {duesForSee}</p>
                </th>
              </tr>
            </thead>
          </table>
          <button
            onClick={() => handleOrder()}
            disabled={loading}
            className={`bg-blue-500 px-6 py-1 text-white font-bold mx-auto block mt-4 `}
          >
            {loading ? "Loading..." : "Submit"}
            {/* <Link to="/dashboard/order/invoice" state={passData}>Submit</Link> */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProServiceBill;
